var map = {
	"./DDJM.svg": 31358,
	"./HRA_ARCHITEKCI.svg": 13276,
	"./JEMS.svg": 94923,
	"./JSK.svg": 33710,
	"./Q2_STUDIO.svg": 45890,
	"assets/images/architekci/DDJM.svg": 31358,
	"assets/images/architekci/HRA_ARCHITEKCI.svg": 13276,
	"assets/images/architekci/JEMS.svg": 94923,
	"assets/images/architekci/JSK.svg": 33710,
	"assets/images/architekci/Q2_STUDIO.svg": 45890
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14046;